import { io } from 'socket.io-client';
import { baseUrl } from '../constants/backendUrls';

let socket = io(baseUrl, { transports: ['websocket'] });

export default socket;